module.exports = __webpack_public_path__ + "img/circular_economy.9f73d5d.svg";